import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('leads-receptions-waiting', storeModule.createStoreModule('leads-receptions-waiting'))
